import { HubApiMethods } from '../../constants/HubApiMethods';
import { addLoginQueryParams } from '../../utils/url';
import { appendUnityLoginIframe } from '../../utils/landing';
import { HubJsonRpcRequest } from '../../api/HubJsonRpcRequest';
import { GetUserTokenType } from '../../domains/valueObject/SwitchUserProgressResponses';
import { CustomJrpcErrResult } from '../../general/modules/jsonRpc/jRpcErrResponse';
import { MailingUser } from "./MailingUser";
import { getUrlToLoginViaToken } from "../getUrlToLoginViaToken";

export class MailingLogin {
    private mailingUser: MailingUser;

    constructor(mailingUser: MailingUser) {
        this.mailingUser = mailingUser;
    }

    public async auth(): Promise<void> {
        try {
            const hubResponse: CustomJrpcErrResult | GetUserTokenType = await HubJsonRpcRequest.makeRequest(
                HubApiMethods.GET_TOKEN_BY_MAILING_TOKEN,
                {
                    locale: this.mailingUser.getLocale(),
                    entryPoint: this.mailingUser.getEntryPoint(),
                    mailingToken: this.mailingUser.getMailingToken(),
                    suid: this.mailingUser.getSuid(),
                    generatedAt: this.mailingUser.getGeneratedAt(),
                },
                this.mailingUser.getDeviceId()
            );

            if ('error' in hubResponse) {
                throw new Error(hubResponse.error.message);
            }

            let url = getUrlToLoginViaToken(hubResponse.tether.token, hubResponse.tether.suid);
            url = addLoginQueryParams(url);
            appendUnityLoginIframe(url);
        } catch (exception) {
            window.Sentry.captureException(`Got exception on mailing login ${JSON.stringify(exception)}`);
        }
    }
}
